import React from "react";
import SEO from "@/components/SEO";
import LocationTemplate from "@/components/LocationTemplate";

const UpfieldPage = () => <LocationTemplate suburbName="Upfield" suburbSlug="upfield" />;

export default UpfieldPage;